var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "save_alt-24px",
    width: 22.763,
    height: 22.763,
    viewBox: "0 0 22.763 22.763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    fill: "none",
    d: "M0 0h22.763v22.763H0z",
    "data-name": "Path 295"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    d: "M18.18 11.539v6.641H4.9v-6.641H3v6.641a1.9 1.9 0 0 0 1.9 1.9h13.28a1.9 1.9 0 0 0 1.9-1.9v-6.641zm-5.693.636l2.457-2.448 1.338 1.338-4.744 4.744L6.8 11.064l1.333-1.337 2.457 2.448V3h1.9z",
    "data-name": "Path 296",
    transform: "translate(-.157 -.157)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.2a0d50d5.svg";
export { ForwardRef as ReactComponent };